import { createEffect, createStore } from "effector";
import { Location } from "../models";
import { confirmChangeBaseSelections } from "./confirmChangeFns";
import { resetAllSelectedStores } from "./resetAllSelected";

export const $selectedLocation = createStore<Location | null>(null).reset(
  resetAllSelectedStores
);
export const setSelectedLocation = createEffect(
  async (value: Location): Promise<Location> => {
    if (!(await confirmChangeBaseSelections())) {
      throw new Error("User declined date range change.");
    }
    return value;
  }
);
$selectedLocation.on(setSelectedLocation.doneData, (s, value) => value);
